(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-nav-buttons"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var bars = document.querySelectorAll('[id^="CatNavBar-"]');
    bars.forEach(function (bar) {
      var toggleBtn = bar.querySelector('.cat-nav-btn--toggle');
      if (!toggleBtn) return;
      var panelId = toggleBtn.getAttribute('data-toggle');
      var panel = document.getElementById(panelId);
      if (!panel) return;
      toggleBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = panel.classList.contains('is-open');
        panel.classList.toggle('is-open', !isOpen);
        panel.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
        toggleBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
